import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=713d5506"
import script from "./Diversity.vue?vue&type=script&lang=ts"
export * from "./Diversity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports